import React, { useState } from "react";
import logo from "../../assets/logo.svg"
import { Button } from "../Button/index"
import topImg from "../../assets/top-head-img.svg"
import DownImg from "../../assets/down-img.png"
import menuBar from "../../assets/menu.svg"
import "./index.css"
import closeCircle from "../../assets/close-circle.svg"
import { Drawer } from "antd";
export const ExternalPageHeader = () => {
    const [isOpen, setIsOpen] = useState(false);
    const active = window.location.pathname.replace('/', '')
    const [open, setOpen] = useState(false)

    const toggle = () => setIsOpen(!isOpen);


    return (
        <div className="container-head">
            <header className="animate__animated  animate__backInDown show-web-int">
                <div className="d-flex justify-content-between align-items-center ">
                    <div className="logo-art pl-3">
                        <img src={logo} />
                    </div>
                    <div className="head-menu font-pop">
                        <div className="d-flex align-items-center">
                            <div className="pr-5">Services</div>
                            <div className="pr-5">How it works</div>
                            <div className="pr-5">Reviews</div>
                            <div>Contact us</div>

                        </div>
                    </div>
                    <div></div>



                </div>
                <div className="position-relative">
                    <div className="top-r-image animate__animated animate__backInDown">
                        <img src={topImg} />
                        <div className="menu-b">
                        <div className="d-flex align-items-center ">
                            <Button className="secondary-button mr-3" text="Join as Artisan" />
                            <Button className="primary-button" text="Get Started" />
                        </div>
                    </div>
                    </div>
                    <div className="down-r-image">
                        <img src={DownImg} />
                    </div>

                </div>



            </header>
            <header className="show-mobile-int">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <div className="logo-art">
                            <img src={logo} />
                        </div>
                    </div>
                    <div onClick={() => setOpen(true)}>
                        <img src={menuBar} />

                    </div>
                </div>
            </header>
            <Drawer
                title=""
                closable={{ 'aria-label': 'Close Button' }}
                onClose={() => setOpen(false)}
                open={open}
                width={"100%"}
            >
                <div className="">
                    <div className="d-flex justify-content-end" onClick={() => setOpen(false)}
                    >
                        <img src={closeCircle} />
                    </div>
                    <div>
                        <div className=" menu-mobile">
                            Services
                        </div>
                        <div className=" menu-mobile">
                            How it Works
                        </div>
                        <div className=" menu-mobile">
                            Reviews
                        </div>
                        <div className=" menu-mobile">
                            Contact Us
                        </div>
                        <div className=" menu-mobile">
                            About Us
                        </div>
                        <div className=" menu-mobile">
                            Blogs
                        </div>

                        <div className="d-flex justify-content-center">
                            <div>
                                <Button className="secondary-button" text="Join as Artisan" />
                                <Button className="primary-button mt-4" text="Get Started" />
                            </div>
                        </div>

                    </div>
                </div>

            </Drawer>
        </div>
    );
};

